const ManageContactDetails = () => {
  return <div style={{ maxWidth: '900px' }}>Contact Details Management</div>;
};

export default ManageContactDetails;
